module.exports = __webpack_public_path__ + "card-icon.81d393f6.png";